import React from 'react';
import { Molecule, Wrapper, wrap, Atom } from 'AppReact';
import styled, { css } from 'styled-components';
import CloseButton from './atoms/closeButton';
import { SecondaryTextXXLBold } from 'atoms';
import { FlexCenterJustifyCenterWrapper, Mt4, Mr3, Mt5 } from 'wrappers';

const template = styled.div`
  ${({ theme }) => css`
    background: ${`${theme.colour?.primary}0D`};
    padding: 19px 19px 30px 63px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
    position: relative;
    flex-grow: 0;
  `}
`

const imgTemplate = styled.img`
    object-fit: contain;
    width: 165px;
    height: 80px;
`;


const img = Atom({ type: 'image', dataType: 'string', template: imgTemplate });


export default Molecule({
    template,
    type: '',
    atoms: [
        {
            component: wrap(CloseButton, Wrapper(styled.div`display: flex; justify-content: flex-end; float: right`)),
            name: 'CloseButton',
            displayState: () => ({ viewBox: "0 0 36 36" }),
            displayValue: () => <>
                <g>
                    <rect width="32" height="32" rx="16" transform="matrix(-1 0 0 1 34 1)" fill="white" />
                    <rect x="-0.5" y="0.5" width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 33 1)" />
                </g>
                <path d="M20.9989 14.0037L15.0039 19.9974" stroke={window?.settings?.secondary_color ?? '#04333b'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 20L15 14" stroke={window?.settings?.secondary_color ?? '#04333b'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </>
        },
        {
            wrapper: wrap(FlexCenterJustifyCenterWrapper, Mt5),
            name: 'TitleArea',
            atoms: [
                {
                    component: wrap(wrap(SecondaryTextXXLBold, Mr3), Mt4),
                    name: 'Title',
                    displayValue: ({ title }) => title
                },
                {
                    component: img,
                    name: 'Image',
                    displayValue: ({ src }) => src,
                },
                {
                    component: wrap(wrap(SecondaryTextXXLBold, Mr3), Mt4),
                    name: 'ExclamationMark',
                    displayValue: ({ }) => '!'
                },
            ]
        }
    ]
})